import { Link } from "react-router-dom";

const SOURCES = {
  horizontal: "/logo-horizontal.png",
  stacked: "/logo.png",
  wordmark: "/logo-wordmark.png",
  mark: "/logo-mark.png",
};

export const Logo = ({ variant = "horizontal", className = "h-10 md:h-11" }) => (
  <Link to="/" data-testid="logo-link" className="group flex items-center">
    <img
      src={SOURCES[variant]}
      alt="ZELVORIA — Timeless Elegance. In Every Detail."
      data-testid="logo-image"
      className={`${className} w-auto transition-opacity duration-500 group-hover:opacity-75`}
    />
  </Link>
);
